import { gql } from '@apollo/client'
import { PRODUCT_IMAGE_FRAGMENT } from './ProductImageFragment'
import { PACKAGING_FRAGMENT } from './PackagingFragment'
import { SHIPPING_FRAGMENT } from './ShippingFragment'

export const PRODUCT_FRAGMENT = gql`
  fragment Product on Product {
    id
    created
    modified
    upcA
    upcE
    name
    isActive
    brand {
      id
      name
    }
    manufacturer {
      id
      name
    }
    marketingImageUrl
    images(verified: false, hasPrediction: true) {
      ...ProductImage
    }
    packaging {
      ...Packaging
    }
    shipping {
      ...Shipping
    }
    verifiedBy
  }
  ${PRODUCT_IMAGE_FRAGMENT}
  ${PACKAGING_FRAGMENT}
  ${SHIPPING_FRAGMENT}
`
